
/* =======================================
Cross-sell Image Quality Enhancer
======================================= */
function updateCrossSellImageQuality(images) {
  images.forEach((img) => {
    const src = img.getAttribute('src');
    if (!src) return;

    const cleanSrc = src.split('?')[0] + '?width=768';
    img.setAttribute('src', cleanSrc);
    if (img.hasAttribute('srcset')) {
      img.setAttribute('srcset', cleanSrc);
    }
  });
}

function updateAttributes(sliders) {
  sliders.forEach(slider => {
    slider.removeAttribute('aria-hidden');
  })
}


function crossSellFunc() {
  const crossSellBlock = document.querySelector('essential-upsell-cross-sell-app-block');
  if (!crossSellBlock) return;

  const crossSellObserver = new MutationObserver(() => {
    const images = crossSellBlock.querySelectorAll('[data-essential-upsell-element="image"]');
    const productSliders = crossSellBlock.querySelectorAll('[data-essential-upsell-element="products"] div[role="group"][aria-hidden]');

    if(images.length > 0) updateCrossSellImageQuality(images);
    if(productSliders.length > 0) updateAttributes(productSliders);
  });

  crossSellObserver.observe(crossSellBlock, {
    childList: true,
    subtree: true,
  });
}

crossSellFunc();
